import { useState } from 'react';

/**
 * Custom hook for handling table frontend pagination. This hooks assumes that you have all of your data currently loaded in the frontend.
 *
 * @template T - The type of data being paginated.
 * @param {T[]} data - The array of data to paginate.
 * @param {number} rowsPerPage - The number of rows to display per page.
 * @returns {{
 *   currentPage: number;
 *   setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
 *   currentData: T[];
 *   totalNumberOfPages: number;
 * }} An object containing the current page, a function to set the current page,
 *     the data for the current page, and the total number of pages.
 */
export const useTablePagination = <T>(data: T[], rowsPerPage: number) => {
	const [currentPage, setCurrentPage] = useState(1);

	const currentData = data.slice(
		(currentPage - 1) * rowsPerPage,
		currentPage * rowsPerPage,
	);
	const totalNumberOfPages = Math.ceil(data.length / rowsPerPage);

	return {
		currentPage,
		setCurrentPage,
		currentData,
		totalNumberOfPages,
	};
};
